import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import StatesValidationSchema from "../Validations/AcademicsValidation";
import Staets from "./States";

//  Indian States list with unionTerritories
const indianStates = [
  { id: 1, code: "AP", name: "Andhra Pradesh" },
  { id: 2, code: "AR", name: "Arunachal Pradesh" },
  { id: 3, code: "AS", name: "Assam" },
  { id: 4, code: "BR", name: "Bihar" },
  { id: 5, code: "CG", name: "Chhattisgarh" },
  { id: 6, code: "GA", name: "Goa" },
  { id: 7, code: "GJ", name: "Gujarat" },
  { id: 8, code: "HR", name: "Haryana" },
  { id: 9, code: "HP", name: "Himachal Pradesh" },
  { id: 10, code: "JH", name: "Jharkhand" },
  { id: 11, code: "KA", name: "Karnataka" },
  { id: 12, code: "KL", name: "Kerala" },
  { id: 13, code: "MP", name: "Madhya Pradesh" },
  { id: 14, code: "MH", name: "Maharashtra" },
  { id: 15, code: "MN", name: "Manipur" },
  { id: 16, code: "ML", name: "Meghalaya" },
  { id: 17, code: "MZ", name: "Mizoram" },
  { id: 18, code: "NL", name: "Nagaland" },
  { id: 19, code: "OD", name: "Odisha" },
  { id: 20, code: "PB", name: "Punjab" },
  { id: 21, code: "RJ", name: "Rajasthan" },
  { id: 22, code: "SK", name: "Sikkim" },
  { id: 23, code: "TN", name: "Tamil Nadu" },
  { id: 24, code: "TG", name: "Telangana" },
  { id: 25, code: "TR", name: "Tripura" },
  { id: 26, code: "UP", name: "Uttar Pradesh" },
  { id: 27, code: "UK", name: "Uttarakhand" },
  { id: 28, code: "WB", name: "West Bengal" },
  { id: 29, code: "AN", name: "Andaman and Nicobar Islands" },
  { id: 30, code: "CH", name: "Chandigarh" },
  { id: 31, code: "DN", name: "Dadra and Nagar Haveli and Daman and Diu" },
  { id: 32, code: "DL", name: "Delhi" },
  { id: 33, code: "JK", name: "Jammu and Kashmir" },
  { id: 34, code: "LA", name: "Ladakh" },
  { id: 35, code: "LD", name: "Lakshadweep" },
  { id: 36, code: "PY", name: "Puducherry" },
];

function StateModal({ States, open, onClose, statesEdit, onSuccess }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [states, setStates] = useState([]);
  console.log(statesEdit);

  // Fetch dropdown data once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const statesRes = await api.get("/getAllStates");
        setStates(statesRes.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      name: statesEdit?.name || "",
      code: statesEdit?.code || "",
      image: statesEdit?.image || "",
      thumbnail: statesEdit?.thumbnail ?? "",
      active: statesEdit?.active || "true",
      // The state update replaces toast fields too; keep the saved toast when editing
      ...(statesEdit?.id && {
        toastMessage: statesEdit.toastMessage ?? null,
        showToast: statesEdit.showToast ?? null,
      }),
    },

    validationSchema: StatesValidationSchema.StatesValidationSchema(states),
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log(statesEdit?.id);
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (statesEdit?.id) {
          response = await api.put(`/api/states/${statesEdit?.id}`, values);
          console.log(values);
        }

        // Else it's Add data it will call Add api
        else {
          console.log(values);

          response = await api.post("/api/states", values);
        }
        // Show success toast
        toast.success(
          `States ${statesEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {statesEdit && Object.keys(statesEdit).length > 0
              ? "Update State"
              : "Add State"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <FormControl
              fullWidth
              error={formik.touched.name && Boolean(formik.errors.name)}
            >
              <InputLabel>State Name</InputLabel>
              <Select
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                label="State Name"
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 400,
                    },
                  },
                }}
              >
                {indianStates.map((u) => (
                  <MenuItem key={u.id} value={u.name}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.name && formik.errors.name && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.name}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl
              sx={{ marginTop: "15px" }}
              fullWidth
              error={formik.touched.code && Boolean(formik.errors.code)}
            >
              <InputLabel>State code</InputLabel>
              <Select
                name="code"
                value={formik.values.code}
                onChange={formik.handleChange}
                label="State Code"
                onBlur={formik.handleBlur}
                error={formik.touched.code && Boolean(formik.errors.code)}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 400,
                    },
                  },
                }}
              >
                {indianStates.map((u) => (
                  <MenuItem key={u.id} value={u.code}>
                    {u.code} {"-"} {u.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.code && formik.errors.code && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.code}
                </FormHelperText>
              )}
            </FormControl>
            <TextField
              label="Image Url"
              name="image"
              value={formik.values.image}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.image && Boolean(formik.errors.image)}
              helperText={formik.touched.image && formik.errors.image}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="thumbnail Url"
              name="thumbnail"
              value={formik.values.thumbnail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.thumbnail && Boolean(formik.errors.thumbnail)
              }
              helperText={formik.touched.thumbnail && formik.errors.thumbnail}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>

            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default StateModal;
